/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Google_Analytics_IdInputs */

const en_admin_settings_fields_google_analytics_id = /** @type {(inputs: Admin_Settings_Fields_Google_Analytics_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measurement ID`)
};

/**
* | output |
* | --- |
* | "Measurement ID" |
*
* @param {Admin_Settings_Fields_Google_Analytics_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_google_analytics_id = /** @type {((inputs?: Admin_Settings_Fields_Google_Analytics_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Google_Analytics_IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_google_analytics_id(inputs)
});
export { admin_settings_fields_google_analytics_id as "admin.settings.fields.google_analytics_id" }